import axios from "axios";

const API_LUMEN = process.env.REACT_APP_API_URL;
const API_GO = process.env.REACT_APP_API_GO;

const getApiUrl = (api = "lumen") => {
	return api === "go" ? API_GO : API_LUMEN;
};

export const downloadFile = async ({ url, params, api = "lumen" }) => {
	const apiUrl = getApiUrl(api);
	const { data } = await axios.get(`${apiUrl}${url}`, {
		params,
		headers: {
			Authorization: localStorage.getItem("token"),
		},
		responseType: "blob",
	});
	return data;
};

export const executeExport = async ({ url, params, key, api = "lumen" }) => {
	const apiUrl = getApiUrl(api);
	const { data } = await axios.get(`${apiUrl}${url}`, {
		params: { ...params, key },
		headers: {
			Authorization: localStorage.getItem("token"),
		},
	});
	return data;
};

export const checkExportStatus = async ({ uuid, api = "lumen" }) => {
	const apiUrl = getApiUrl(api);
	const { data } = await axios.get(`${apiUrl}/client/export_excel_check`, {
		params: { uuid },
		headers: {
			Authorization: localStorage.getItem("token"),
		},
	});
	return data;
};

export const downloadExportedFile = async ({ uuid, api = "lumen" }) => {
	const apiUrl = getApiUrl(api);
	const { data } = await axios.get(`${apiUrl}/client/export_excel_download`, {
		params: { uuid },
		headers: {
			Authorization: localStorage.getItem("token"),
		},
	});
	return data;
};
